export const isThereFilterInRouteSelector = (): boolean => {
    const path = document.location.pathname.split('/');
    const isFilter = path[path.length - 1] === 'filter';
    return isFilter;
};
